import {
  CloseOutlined,
  DownloadOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { Button, notification, Progress } from 'antd';
import { parse } from 'json2csv';
import React, { useRef, useState } from 'react';
import { CSVLink } from 'react-csv';

import { fetchAPI } from '../../../utils/api';
import { useOrderV2QueryParams } from './OrderListingV2';

const notificationKey = 'download-order-items-v2';
const DownloadOrderItems = props => {
  const [queryParams] = useOrderV2QueryParams();
  const [downloading, setDownloading] = useState(false);
  const downloadRef = useRef(false);

  const startDownload = async (prevItems = [], page = 1, total = 0) => {
    if (page > 1 && !downloadRef.current) {
      return;
    }

    setDownloading(true);
    downloadRef.current = true;
    let percentage = 0;
    if (total > 0) {
      const totalPages = Math.ceil(total / 10);
      percentage = Math.round(((page - 1) / totalPages) * 100);
    }

    notification.open({
      key: notificationKey,
      message: 'Download Orders Items',
      description: <Progress percent={percentage} />,
      duration: 0,
      onClose: () => {
        downloadRef.current = false;
        setDownloading(false);
      },
    });

    try {
      // const _picks = [
      //   'id',
      //   'order_id',
      //   'name',
      //   'quantity',
      //   'price',
      //   'cost',
      //   'origin_price',
      //   'shipping_fee',
      //   'currency',
      //   'note',
      //   'category',
      //   'category_item_name',
      //   'tax_rate',
      //   'paid_by',
      //   'is_ncpr',
      //   'mp_order_package_id',
      //   'expected_delivery_date',
      //   'is_fulfilled',
      //   'fulfilled_quantity',
      //   'spid_no',
      //   'spid_item_number',
      // ];

      const filters = Object.keys(queryParams).reduce((obj, qpKey) => {
        if (qpKey.startsWith('filter_')) {
          const arr = queryParams[qpKey];
          if (!!arr && !!arr.length) {
            return {
              ...obj,
              [qpKey.replace('filter_', '')]: arr,
            };
          }
        }

        return obj;
      }, {});

      const resp = await fetchAPI('order/items/download', {
        method: 'POST',
        payload: {
          page,
          per_page: queryParams.per_page,
          q: queryParams.q,
          q_assignee: queryParams.q_assignee.join(''),
          is_internal_purchase:
            typeof queryParams.is_internal_purchase === 'boolean'
              ? queryParams.is_internal_purchase
              : undefined,
          from_date: !!queryParams.date_start
            ? queryParams.date_start
            : undefined,
          to_date: !!queryParams.date_end ? queryParams.date_end : undefined,
          date_type: queryParams.date_type,
          filters,
        },
      });

      const allItems = [...prevItems, ...resp.items];
      if (resp.total > resp.page * resp.per_page) {
        return startDownload(allItems, page + 1, resp.total);
      } else {
        notification.open({
          key: notificationKey,
          message: 'Finished Download Order Items',
          description: (
            <CSVLink
              filename={'SA Download Order Items.csv'}
              data={parse(allItems)}
            >
              Click to Download
            </CSVLink>
          ),
          duration: 0,
          onClose: () => {
            downloadRef.current = false;
            setDownloading(false);
          },
        });
      }
    } catch (error) {
      const totalPages = total > 0 ? Math.ceil(total / 10) : 1;
      notification.open({
        key: notificationKey,
        message: 'Failed Download Order Items',
        description: (
          <span style={{ color: 'red' }}>
            <CloseOutlined /> Failed download order items on page {page} of{' '}
            {totalPages} pages
          </span>
        ),
        duration: 0,
        onClose: () => {
          downloadRef.current = false;
          setDownloading(false);
        },
      });
    }
  };

  return (
    <Button
      icon={downloading ? <LoadingOutlined /> : <DownloadOutlined />}
      loading={downloading}
      onClick={() => startDownload()}
    >
      Download Order Items
    </Button>
  );
};

export default DownloadOrderItems;
